import { render, staticRenderFns } from "./WithdrawUSDT.vue?vue&type=template&id=3f6885f4&scoped=true"
import script from "./WithdrawUSDT.vue?vue&type=script&lang=js"
export * from "./WithdrawUSDT.vue?vue&type=script&lang=js"
import style0 from "./WithdrawUSDT.vue?vue&type=style&index=0&id=3f6885f4&prod&lang=css"
import style1 from "./WithdrawUSDT.vue?vue&type=style&index=1&id=3f6885f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6885f4",
  null
  
)

export default component.exports